var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGitLabWhite = function SvgGitLabWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.193 16.965 2.047 1.553 1.246.944a.84.84 0 0 0 1.017 0l1.246-.944 2.051-1.553-3.807-2.877zM19.664 7.989l-.028-.072a9.2 9.2 0 0 0-3.66 1.646l-5.97 4.525c2.035 1.54 3.807 2.877 3.807 2.877l4.17-3.123.012-.008a5.056 5.056 0 0 0 1.669-5.845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.022 9.567a9.2 9.2 0 0 0-3.66-1.645l-.028.07a5.06 5.06 0 0 0 1.674 5.843l.01.007.024.019 4.147 3.104 3.816-2.877z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.028 14.106-.023-.018 5.97-4.525a9.2 9.2 0 0 1 3.66-1.646L16.918.823a.71.71 0 0 0-.706-.449.711.711 0 0 0-.653.522l-1.84 5.626H6.283L4.444.897A.71.71 0 0 0 3.79.373a.72.72 0 0 0-.707.45l-2.72 7.1a9.2 9.2 0 0 1 3.658 1.644l5.983 4.521-.006.005.023.018z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitLabWhite);
export { ForwardRef as ReactComponent };